import React, { useEffect, useCallback, useState, Fragment } from "react";
import api from "services/api";
import swal from 'sweetalert';

import { Validate } from "common";
import { Page, Form, Loading } from "components";

const statusList = [
  { value: null, label: "Todos os Status" },
  { value: "created", label: "Não iniciado" },
  { value: "started", label: "Em andamento" },
  { value: "finished", label: "Finalizado" },
];

export default function List({ location, ...rest }) {
  const [course, setCourse] = useState(null);
  const [courseClass, setCourseClass] = useState(null);
  const [status, setStatus] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false)

  const handleValidate = useCallback(() => {
    const rules = {
      course: {
        required: true,
      },

      courseClass: {
        required: true,
      },
    };

    const validate = Validate({ course, courseClass }, rules);
    setErrors(validate.errors)

    return validate.valid;
  }, [course, courseClass]);

  const handleDownload = useCallback(async () => {
    if (!handleValidate()) return;

    try {
      setLoading(true)
      const response = await api.get("reports/pdf/course_pdf", {
        params: {
          course_name: course,
          course_class: courseClass,
          interview_status: status,
        },
      });

      window.open(response.request.responseURL);
    } catch (err) {
      swal('Ops... algo deu errado', 'Não foi possível gerar o relatório, verifique se os dados foram preenchidos corretamente', 'error')
    } finally {
      setLoading(false)
    }
  }, [course, courseClass, status]);

  return (
    <Page>
      <div className="row align-items-center">
        <div className="col-6">
          <Page.Title>Relatório de Entrevistas</Page.Title>
        </div>
      </div>

      <div className="alert alert-info">
        Você deve aplicar os filtros para gerar o relatório
      </div>

      <div className="row">
        <div className="col-3 m-b-10">
          <Form.Input
            placeholder="Nome do curso"
            value={course}
            errors={errors.course}
            onChange={(e) => setCourse(e.target.value)}
          />
        </div>

        <div className="col-3 m-b-10">
          <Form.Input
            placeholder="Nome da turma"
            value={courseClass}
            errors={errors.courseClass}
            onChange={(e) => setCourseClass(e.target.value)}
          />
        </div>

        <div className="col-3 m-b-10">
          <Form.Select
            placeholder="Status"
            options={statusList}
            value={statusList.find((option) => option.value === status)}
            onChange={(option) => setStatus(option.value)}
          />
        </div>

        <div className="col-3 m-b-10">
          <button
            type="button"
            className="btn btn-success m-l-10"
            disabled={loading}
            onClick={handleDownload}
          >
            {loading ? <Loading size="small" /> : 'Gerar relatório'}
          </button>
        </div>
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Report/index.js